module.exports = __webpack_public_path__ + "static/media/anatomia.5ecd2925.png";